export const topicIds = {
  products: 'c36e0262-b4f3-4db4-b3bb-7daa80b8e8b0',
  offers: '47a0e43b-4598-457d-a656-6cf3c75f93a3',
  partners: '00000000-0000-0000-0000-000000000003'
} as const;

/**
 * Super simple email validation. Must contain a non-empty name part, one `@`
 * character, and a domain part. The domain part must contain at least one `.`
 * character that is not at the end or beginning of the domain, or twice in a
 * row.
 */
export const emailValidationRx = /^[^@]+@(?:[^.@]+\.)+[^.@]+$/;

/**
 * Super simple phone validation. Match 2-15 digits. The first number cannot
 * be zero.
 */
export const phoneSubscriberValidationRx = /^[1-9]\d{1,14}$/;
